
/*
    Recently Viewed
*/
const initRecentlyViewed = async () => {
  const localStorageKey = 'ecomify_recently_viewed_v1'

  document.querySelectorAll('.recently-viewed:not(.init2)').forEach(section => {
    section.classList.add('init2')

    const recentlyViewed = JSON.parse(localStorage.getItem(localStorageKey)) || []

    let productListItems = ''

    recentlyViewed.forEach((product, index) => {
      if (index + 1 <= Number(section.dataset.limit)) {
        let variantOptions = ''

        product.variants.forEach((variant) => {
          variantOptions += `
            <option 
                value="${variant.id}"
                data-compare-at-price="${variant.compare_at_price || ''}"
                data-price="${variant.price}"
                data-variant-image="${variant.featured_image.src ? Shopify.resizeImage(variant.featured_image.src, `${section.dataset.imgWidth}x${section.dataset.imgHeight}`, 'center') : ''}">
                ${variant.title}
            </option>
                    `
        })

        productListItems += `
          <li class="product-item splide__slide p-3 p-lg-4 mb-4">
              <div class="img-wrapper position-relative mb-4">
                  <div class="" ${section.dataset.showWishlist === 'true' ? '' : 'hidden'}>
                      <button 
                          class="btn-wishlist-add-remove btn"
                          type="button"
                          data-product-handle="${product.handle}"
                          data-text-add="${section.dataset.textWishlistAdd}"
                          data-text-remove="${section.dataset.textWishlistRemove}"
                          aria-label="${section.dataset.textWishlistAdd}"
                          onclick="addOrRemoveFromWishlist(this)">
                          <svg xmlns="http://www.w3.org/2000/svg" class="me-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                          </svg>
                      </button>
                  </div>
                  <a 
                      class="product-link position-relative d-block link-dark" 
                      href="${product.url}">
                      <img 
                          class="product-item-img img-fluid rounded ${section.dataset.imgThumbnail}" 
                          src="${Shopify.resizeImage(product.featured_image || 'no-image.gif', `${section.dataset.imgWidth}x${section.dataset.imgHeight}`, 'center')}"
                          alt="" 
                          width="${section.dataset.imgWidth}"
                          height="${section.dataset.imgHeight}"
                          loading="lazy">
                  </a>
              </div>
              <h3 class="product-item-title mb-2 ${section.dataset.productTitleSize} ${section.dataset.productTitleTruncate}">
                  <a 
                      class="product-link position-relative d-block link-dark" 
                      tabindex="-1"
                      href="${product.url}">
                      ${product.title}
                  </a>
              </h3>
              <div class="shopify-product-reviews-badge" data-id="${product.id}"></div>
              <p class="product-item-price mb-4">
                  <span ${product.compare_at_price > product.price ? '' : 'hidden'}>
                      <span class="product-item-price-compare text-muted me-1">
                          <span class="visually-hidden">
                              ${section.dataset.textPriceRegular} &nbsp;
                          </span>
                          <s>
                              ${Shopify.formatMoney(product.compare_at_price)}
                          </s>
                      </span>
                      <span class="product-item-price-final">
                          <span class="visually-hidden">
                              ${section.dataset.textPriceSale} &nbsp;
                          </span>
                          <span ${product.price_varies ? '' : 'hidden'}>
                              ${section.dataset.textPriceFrom}
                          </span>
                          ${Shopify.formatMoney(product.price)}
                      </span>
                  </span>
                  <span class="product-item-price-final" ${product.compare_at_price > product.price ? 'hidden' : ''}>
                      <span ${product.price_varies ? '' : 'hidden'}>
                          ${section.dataset.textPriceFrom}
                      </span>
                      ${Shopify.formatMoney(product.price)}
                  </span>
              </p>
              <div class="mb-2" ${section.dataset.showAtcForm === 'true' ? '' : 'hidden'}>
                  <form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" onsubmit="onSubmitAtcForm(this, event)">
                      <input type="hidden" name="form_type" value="product">
                      <input type="hidden" name="utf8" value="✓">
                      <select 
                          class="form-select w-100 mb-3" 
                          name="id" 
                          aria-label="${section.dataset.textSelectVariant}"
                          onchange="onChangeProductItemVariant(this, event)"
                          ${product.variants.length === 1 ? 'hidden' : ''}>
                          ${variantOptions}
                      </select>
                      <button
                          class="btn-atc btn btn-md btn-primary w-100" 
                          type="submit"
                          name="add"
                          data-text-add-to-cart="${section.dataset.textAddToCart}">
                          ${section.dataset.textAddToCart}
                      </button>
                  </form>
              </div>
          </li>
        `
      }
    })

    section.querySelector('.product-list').innerHTML = productListItems

    window.SPR?.initDomEls()
    window.SPR?.loadBadges()

    if (recentlyViewed.length > 0) {
      section.removeAttribute('hidden')
    }

    section.classList.remove('init')
    initFeaturedProducts()
  })

  if (document.body.classList.contains('page-type-product')) {
    const productHandle = document.querySelector('#product-template').dataset.productHandle

    const response = await fetch(`${productHandle}.js`)
    const product = await response.json()
    // console.log(product)

    let recentlyViewed = JSON.parse(localStorage.getItem(localStorageKey)) || []
    const isViewed = recentlyViewed.some((elem) => elem.handle === product.handle)

    if (isViewed) {
      recentlyViewed = recentlyViewed.filter(elem => elem.handle !== product.handle)
    }

    const variants = product.variants.map(variant =>
    ({
      id: variant.id,
      title: variant.title,
      compare_at_price: variant.compare_at_price,
      price: variant.price,
      featured_image: {
        src: variant.featured_image?.src || null
      }
    })
    )

    recentlyViewed.unshift({
      id: product.id,
      handle: product.handle,
      url: product.url,
      title: product.title,
      compare_at_price: product.compare_at_price,
      price: product.price,
      price_varies: product.price_varies,
      featured_image: product.featured_image,
      vendor: product.vendor,
      time: Date.now(),
      variants
    })

    if (recentlyViewed.length > 50) {
      recentlyViewed.pop()
    }

    localStorage.setItem(localStorageKey, JSON.stringify(recentlyViewed))
  }
}
initRecentlyViewed()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.recently-viewed')) {
    initRecentlyViewed()
  }
})